// eslint-disable-next-line import/extensions, no-unused-vars
import dotPointTools from '@zn-collect/dot/lib/zn_dot_point_tools.js';
import aliyunDot from '@zn-collect/dot/lib/aliyunDot';

import { isCustomerSaasPrivate } from '@/utils/globalConfig';

// eslint-disable-next-line new-cap
const pointTools = new dotPointTools();

// SaaS 私有化：关闭埋点上报，去掉 /bigdata-log-collect/api/v1/log/collectLog 接口调用
if (isCustomerSaasPrivate()) {
  pointTools.traceClick = () => {};
}

const pointMenus = [
  // 客户管理
  {
    id: '1494574711311552609',
    event_id: 'home_cust_clk',
  },
  // 商户管理
  {
    id: '1494579742622470232',
    event_id: 'home_merchant_clk',
  },
  // 合同管理-和sit不一致
  {
    id: '1551833581347737657',
    event_id: 'home_contract_clk',
  },
  // 商品管理
  {
    id: '1494584548099477522',
    event_id: 'home_commodity_clk',
  },
  // 设备中心-和sit不一致
  {
    id: '1036699636550422528',
    event_id: 'home_commodity_clk',
  },
  // 交撮平台
  {
    id: '1532254742749900905',
    event_id: 'home_copulate_clk',
  },
  // 履约管理-和sit不一致
  {
    id: '1539226236700684420',
    event_id: 'home_perf_clk',
  },
  // 知识库管理
  {
    id: '1539226236700684419',
    event_id: 'home_knowledge_clk',
  },
  // 呼叫中心
  {
    id: '1035612502611419136',
    event_id: 'home_call_clk',
  },
  // 物流管理-生产
  {
    id: '1494586775878881331',
    event_id: 'home_logistics_clk',
  },
  // 财务管理-生产
  {
    id: '1494586922528526389',
    event_id: 'home_finance_clk',
  },
  // 营销增长-生产
  {
    id: '1494913798815993905',
    event_id: 'home_marketing_clk',
  },
  // 订单管理
  {
    id: '1539226236700684366',
    event_id: 'home_order_clk',
  },
];

const accountId = localStorage.getItem('accountId');
const traceClick = (value, isUserId) => {
  if (isUserId && value.content) {
    // eslint-disable-next-line no-param-reassign
    value.content.user_id = accountId;
  }
  pointTools.traceClick(value);
};

// 封装阿里云日志上报方法，供子应用通过 props.util 调用
const sendAliyunLog = (model) => {
  if (!aliyunDot.isInited) {
    // eslint-disable-next-line no-console
    console.warn('[sendAliyunLog] aliyunDot not initialized, log dropped');
    return false;
  }
  return aliyunDot.setAliyunLogs(model);
};

// eslint-disable-next-line import/prefer-default-export
export { pointTools, pointMenus, traceClick, aliyunDot, sendAliyunLog };
